module.exports = __webpack_public_path__ + "static/media/happiest.c3e97775.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/smileys/happiest.svg
// module id = 162
// module chunks = 0